import { useApiClient } from '@hetivo/hetivo-lib-front-utils';
import type { PaginatedResponse, TerritoryWithLocationCount } from '@hetivo/hetivo-lib-types';
import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { createTerritoryApi, territoryKeys } from '../api';
import type { SearchTerritoriesParams } from '../api';

export interface UseTerritoriesOptions extends SearchTerritoriesParams {
  enabled?: boolean;
}

export function useTerritories(
  params: UseTerritoriesOptions,
): UseQueryResult<PaginatedResponse<TerritoryWithLocationCount>> {
  const { enabled = true, ...searchParams } = params;
  const client = useApiClient('admin-auth');
  const api = createTerritoryApi(client);

  return useQuery({
    enabled,
    gcTime: 5 * 60_000,
    queryFn: () => api.searchTerritories(searchParams),
    queryKey: territoryKeys.search(searchParams),
    staleTime: 30_000,
  });
}
